exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-chat__img {\n  display: inline-block;\n  width: 30px;\n  height: 30px;\n}", ""]);

// exports
